export const PREFIX = 'AddOnAiFeature';
export const ADD_ON_AI_FEATURE_LLM_CONFIGURATION = PREFIX + '.LlmConfiguration';
export const ADD_ON_AI_FEATURE_MODEL = PREFIX + '.Model';
export const ADD_ON_AI_FEATURE_MODEL_NAME = PREFIX + '.ModelName';
